import { Pipe, PipeTransform, inject } from '@angular/core';
import { PublicSalesAvailabilityLabelProviderService } from '../providers/public-sales-availability-label-provider.service';
import { Observable } from 'rxjs';
import { PublicAvailability } from '../enums/public-availability';

@Pipe({
  name: 'publicSalesAvailabilityLabel',
  standalone: true,
})
export class PublicSalesAvailabilityLabelPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly provider = inject(PublicSalesAvailabilityLabelProviderService);

  public transform(status: PublicAvailability): Observable<string> {
    return this.provider.label(status);
  }
}
